/**
 * FramesTable — таблица для камер типа PEOPLE.
 * Тонкая обёртка над FramesTableBase с набором колонок для страницы "Кадры".
 */
import React from "react";
import FramesTableBase, { formatDateTime, getShiftByTime } from "../../components/FramesTableBase/FramesTableBase";

const STORAGE_KEY = "framesTable_columns_v2";

const FRAMES_COLUMNS = [
  {
    key: "date",
    label: "Дата",
    render: (frame, _shifts, timezone) => formatDateTime(frame.created_at, frame.display_timezone || timezone),
    filterType: "date",
    defaultVisible: true,
    hideable: true,
  },
  {
    key: "shift",
    label: "Смена",
    render: (frame, shifts, timezone) => getShiftByTime(frame.created_at, shifts, frame.display_timezone || timezone),
    filterType: "shift",
    defaultVisible: true,
    hideable: true,
  },
  {
    key: "people",
    label: "Людей",
    render: (frame) => frame.people_count ?? 0,
    filterType: "people",
    defaultVisible: true,
    hideable: true,
  },
  {
    key: "people_type",
    label: "Тип людей",
    render: (frame) =>
      frame.people_type?.length ? frame.people_type.join(", ") : "—",
    filterType: "text",
    filterKey: "people_type",
    defaultVisible: true,
    hideable: true,
  },
  {
    key: "gloves",
    label: "Перчатки",
    render: (frame) => frame.gloves ?? 0,
    filterType: null,
    defaultVisible: true,
    hideable: true,
  },
  {
    key: "masks",
    label: "Маски",
    render: (frame) => frame.masks ?? 0,
    filterType: null,
    defaultVisible: true,
    hideable: true,
  },
  {
    key: "headwear",
    label: "Головной убор",
    render: (frame) => frame.hats ?? 0,
    filterType: null,
    defaultVisible: true,
    hideable: true,
  },
  {
    key: "uniform",
    label: "Униформа",
    render: (frame) => frame.uniform_count ?? 0,
    filterType: null,
    defaultVisible: true,
    hideable: true,
  },
  {
    key: "boots",
    label: "Сапоги",
    render: (frame) => frame.boots_count ?? 0,
    filterType: null,
    defaultVisible: true,
    hideable: true,
  },
];

const FramesTable = (props) => (
  <FramesTableBase
    {...props}
    columns={FRAMES_COLUMNS}
    storageKey={STORAGE_KEY}
  />
);

export default FramesTable;
